import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import Paginate from "vuejs-paginate";
import { Validator } from "vee-validate";
import VueAlertify from 'vue-alertify';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: "agentHandoverDashboard",
  components: { Paginate,VueElementLoading },
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      pageCount: 0,
      pageNo: 0,
      fromDate: "",
      toDate: "",
      processmode: "",
      status: "",
      returnArray: [],
      agentDetailss: [],
      agentDetails: [],
      agentShipmentDetails: [],
      hubDetails:[],
      isLoading: false,
      localusermailid: '',
      rowcount:null,
      userDataKey : '',
    };
  },
  computed: {},
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    this.getIntializeValue();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail.userid
    this.createdBy = userdetail.userid
    this.hubdetails = userdetail.hubdetails[0];
    this.userfullname = userdetail.username;
    this.mobilenumber = userdetail.mobilenumber;
    this.localusermailid = userdetail.email;
    this.outsourcingid = userdetail.outsourcingid;
    this.rolename = userdetail.userrole[0]["rolename"];

    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.userid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
  },
  methods: {
    searchAgent(pageNum) {
      this.isLoading = true;
      let obj = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        processmode: this.processmode,
        status: this.status,
        outsourcingid: this.outsourcingid,
        rolename : this.rolename,
        HubId : this.hubdetails,
        limit: 50,
        offset: 0
      };

      if (pageNum > 1){
        obj.offset = pageNum -1 * obj.limit;
      }

      axios({
        method: "POST",
        url: apiUrl.api_url + 'AgentHandoverDashboard/getAllAgents',
        data: obj,
        header: {
          "content-type": "application/json"
        }
      }).then(
      result => {
        if(result && result.data.code !==204){
            let totalRows = Number(result.data.TotalRowCount);
            this.rowcount = totalRows;

            if (totalRows < 50) {
               this.pageCount = 1;
             } else {
               this.pageCount = Math.ceil(totalRows / 50)
             }
              this.returnArray = result.data.data;
              let objArray=this.returnArray;
              this.showTable = true;
              this.agentDetailss=[];
              Promise.all(this.returnArray.map(obj =>{
                  let payload={
                    id:obj.hubid
                  }
                  let finalobj={
                    batchid:obj.batchid,
                    total_shipments:obj.total_shipments,
                    inscan:obj.inscan,
                    pendinginscan:obj.pendinginscan,
                    shortage:obj.shortage,
                    overage:obj.overage,
                    status:obj.status,
                    couriercompanyname:obj.couriercompanyname,
                    createddate:obj.createddate
                  }
                    axios({
                      method: "POST",
                      url: apiUrl.api_url + 'external/getHubServiceCenterDetails',
                      data: payload,
                      header: {
                        "content-type": "application/json"
                      }
                    }).then(result=> {
                        if (result.data.code !== 202){
                          obj.hubname = result.data.data[0].HubName;
                          finalobj.hubname=result.data.data[0].HubName;
                        }

                        this.agentDetailss.push(obj);
                        this.agentDetails.push(finalobj);

                      },
                      error => {
                          this.isLoading = false;
                        console.error("error:", error);
                      }
                    );
              })
            )
            this.isLoading = false;
          }else {
          this.$alertify.alert("Agent Details not found");
          this.isLoading = false;
          }
        },
        error => {
          this.isLoading = false;
          console.error("error:", error);
        }
      );
    },

    getAgentShipmentDetails(id, handovermode, hubid) {
      let obj = {
        batchid: id,
        processmode: handovermode,
        hubid: hubid
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + 'AgentHandoverDashboard/getAgentShipmentDetails',
        data: obj,
        header: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          this.agentShipmentDetails = result.data.data;
          this.showTable = true;
        },
        error => {
          console.error("error:", error);
        }
      );
    },
    getPaginationData(pageNum) {
      // this.pageNo = (pageNum - 1) * 20;
      //  this.getratemasterdata();
      console.log("Printing page Number", pageNum);
      this.pageNo = pageNum;
      this.searchAgent(pageNum);
    },
    getIntializeValue() {
      this.agentShipmentDetails = [];
      this.returnArray = [];
      this.processmode = "Handover";
      this.status = "All";
      this.fromDate = new Date().toISOString().split("T")[0];
      this.toDate = new Date().toISOString().split("T")[0];
    },
    getHubDetails(id){
      let payload={
        id:id
      }
        axios({
          method: "POST",
          url: apiUrl.master_api_url + "expose/hubservicecenter/hub/get",
          data: payload,
          header: {
            "content-type": "application/json"
          }
        }).then(
          result => {
            this.hubDetails = result.data.data;
          },
          error => {
            console.error("error:", error);
          }
        );
    },
    onDateChange(){
      let fromD=new Date(this.fromDate);
      let toD=new Date(this.toDate);
      if(fromD>toD){
        this.$alertify.alert("Date alert","To date should be greater than from date.");
        //alert("To date should be greater than from date.");
      }
    },
    downloadAgentData(){
      this.isLoading = true;
      if(this.returnArray.length==0){
        this.$alertify.alert("No data","No data available for download.");
        //alert("No data available for download.");
      }
      this.getDownloadCsvObject(this.returnArray);
      this.isLoading = false;
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "AgentHandoverData_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      //link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;

      });
      return result;
   },

    onSubmit: function(event) {
      this.$validator
        .validateAll()
        .then(result => {
          this.searchAgent();
          if (!result) {
            return false;
          }
        })
        .catch(() => {
          console.log("errors exist", this.errors);
        });
    },
    resetForm() {
      this.agentShipmentDetails = [];
      this.returnArray = [];
      this.fromDate = "";
      this.toDate = "";
    },

  }
};



// WEBPACK FOOTER //
// ./src/views/components/agentHandoverDashboard/agentHandoverDashboard.component.js